import React from 'react'
import * as Component from './MapPrivacyPolicy.styles'
import { Button } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import PropTypes from 'prop-types'

const MapPrivacyPolicy = ({ onActivateClick }) => {
  const textContext = React.useContext(TextContext)
  return (
    <Component.PrivacyPolicyContainer data-cy='map-privacy-policy-container'>
      {textContext['mapPrivacyPolicy.Text']}
      <a href='https://www.aok.de/pk/uni/inhalt/datenschutzerklaerung/'>
        {textContext['mapPrivacyPolicy.Link']}
      </a>
      .
      <Component.PrivacyPolicyButtonRow>
        <Button
          id='map-privacy-policy-button'
          data-cy='map-privacy-policy-button'
          text={ textContext['mapPrivacyPolicy.Button'] }
          onClick={ onActivateClick }
        />
      </Component.PrivacyPolicyButtonRow>
    </Component.PrivacyPolicyContainer>
  )
}

MapPrivacyPolicy.propTypes = {
  onActivateClick: PropTypes.func.isRequired,
}

export default MapPrivacyPolicy
